// extracted by mini-css-extract-plugin
export default {"SubSection":"WildlifeManagement-PDF-style_SubSection__fFGW-","Disclaimer":"WildlifeManagement-PDF-style_Disclaimer__JPmxW","Bordered":"WildlifeManagement-PDF-style_Bordered__ZAq6z"};